<div style="width: 700px; height: 350px; margin: 10px">
    <label style="font-size: 18px;" >Payment method:</label>
    <label style="font-size: 12px; margin-left: 20px" [style.color]="messageColor">{{billMessage}}</label>
    <div style="padding-top: 10px;">
         <div #cardElement id="card-element" style="width:100%; padding-top: 20px"></div>
         <form style="padding-top: 20px" [formGroup]="billForm" novalidate>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>Name on Card</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="cardholder" type="text" autocomplete="off">
                 </mat-form-field>
             </div>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>address1</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="address1" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>address2</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="address2" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>city</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="city" type="text" autocomplete="off">
                 </mat-form-field>
             </div>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>state</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="state" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>postalCode</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="postalCode" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>country</mat-label>
                     <mat-select placeholder="" formControlName="country" (selectionChange)="onCountry($event.value)">
                         @for (cntry of m_countries; track cntry) {
                            <mat-option [value]="cntry.value">
                                {{ cntry.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    <div>
    <button (click)="onBillingSubmit()" class="subButton" mat-raised-button [disabled]="!canSubmitBilling()">Submit</button>
    <button (click)="onBillingCancel()" class="subButton" mat-raised-button [disabled]="fintechService.busy">Cancel</button>
</div>
